import { ReactNode } from 'react'

type IProps = { isRender?: any; children?: ReactNode; children2?: ReactNode }

/**
 * 两部分内容. 渲染哪一部分
 * @param props isRender: true 渲染 children, false 渲染 children2; children： 可选; children2： 可选
 * @returns JSX.Element
 */
export default function IsRender({ isRender = true, children, children2 }: IProps) {
  if (isRender) return <>{children}</>
  else return <>{children2}</>
}
